import { render, staticRenderFns } from "./ManejoCuentasBanco.vue?vue&type=template&id=d5b64bf0"
import script from "./ManejoCuentasBanco.vue?vue&type=script&lang=js"
export * from "./ManejoCuentasBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports